import React, { useMemo, useCallback, useState, useEffect } from 'react';
import axios from 'axios';
import { useDropzone } from 'react-dropzone';
import faker from 'faker';
import { Typography, Grid, Button, FormControl, Select, MenuItem, Box } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import moment from 'moment';
import { firebaseStore } from '../../storage/base';
import { useClientContext } from '../../context/client_context';
import { baseUrl } from '../../utils/constants';
import { useClaimsContext } from '../../context/claims_context';
import Controls from '../controls/Controls';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

export default function ClaimsDocs(props) {
  const userRefId = sessionStorage.getItem('userRefId');
  const { closePopup, claimId, clientRefId } = props;
  const { claimNo, populateClaimDocuments, currentClaim } = useClaimsContext();
  const { currentClient } = useClientContext();
  console.log('claimId: ', claimId, ' clientRefId:', clientRefId, 'current claima', currentClient);
  const [progres, setProgress] = useState(0);
  const [show, setShow] = useState(false);
  const [docType, setDocType] = useState(0);
  const currDate = moment().format('YYYY-MM-DD h:mm:ss');
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [document, setDocument] = useState({
    OwnerIdentifier: '',
    UploadDate: moment().format(),
    claimRefId: 0,
    DocumentType: 0,
    DocumentPath: '',
    OriginalFileName: '',
    DocumentFilename: '',
    TransportMethod: 2,
    IsValidated: false,
    UploadedByUserRefId: 0,
    MimeType: 'application/octet-stream',
    State: 0,
    clientRefId
  });

  // const saveToDatabase = (e) => {
  //   const jsonDoc = [];
  //   jsonDoc.push(e);

  //   console.log('document stringified now', JSON.stringify(jsonDoc));
  //   fetch(`${baseUrl}/api/client/SaveDocument`, {
  //     method: 'POST',
  //     headers: {
  //       Accept: 'application/json',
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(jsonDoc[0])
  //   })
  //     .then((res) => res.json())
  //     .then(
  //       (result) => {
  //         console.log('document result after save', result);
  //         populateClaimDocuments(claimNo);
  //         closePopup();
  //         // alert('Document saved successfully...');
  //         // notifyPopup(`Document saved successfully...`, 'success');
  //       },
  //       (error) => {
  //         <Alert variant="filled" severity="error">
  //           Error in Saving Document!, {error}
  //         </Alert>;
  //       }
  //     );
  // };

  // const handleSaveFile = (e) => {
  //   setShow(true);
  //   const file = e;
  //   const fileNimo = `${clientRefId}_${faker.datatype.uuid()}_${file[0].name}`;
  //   console.log('original file name', fileNimo);
  //   const storageRef = firebaseStore.storage().ref();
  //   const uploadTask = storageRef.child(`Claims/${fileNimo}`).put(file[0]);
  //   uploadTask.on(
  //     'state_changed',
  //     (snapshot) => {
  //       const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
  //       setProgress(progress);
  //       console.log(`Upload is ${progress}% done`);
  //     },
  //     (error) => {
  //       alert('failed saving file to storage', error);
  //     },
  //     () => {
  //       uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
  //         document.DocumentPath = downloadURL;
  //         document.OriginalFileName = file[0].name;
  //         document.DocumentFilename = fileNimo;
  //         document.OwnerIdentifier = faker.datatype.uuid();
  //         document.ClientRefId = clientRefId;
  //         document.ClaimRefId = claimId;
  //         saveToDatabase(document);
  //       });
  //     }
  //   );
  // };

  const handleDocumentUpload = (e) => {
    setShow(true);
    const formData = new FormData();
    const file = e;
    const fileNimo = clientRefId + file[0].name;
    formData.append('originalFileName', fileNimo);
    formData.append('documentType', document.DocumentType); // currentDocumentType.toString());
    formData.append('ownerIdentifier', currentClient.id);
    formData.append('uploadedByUserRefId', userRefId);
    formData.append('clientRefId', clientRefId);
    formData.append('claimRefId', claimId);
    formData.append('dataFile', file[0]);

    console.log('form data', [...formData]);
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    axios
      .post(`${baseUrl}/api/FileUpload/UploadFiles`, formData, config)
      .then((response) => {
        populateClaimDocuments(claimNo);
        notifyPopup('Document saved successfully...', 'success');
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
        console.log(JSON.stringify(error.response.data.errors));
      });
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      handleDocumentUpload(acceptedFiles);
    },
    [currentClient]
  );

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    openDialog
  } = useDropzone({ onDrop, accept: ['image/*', 'video/*', '.pdf'] });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const fileNames = acceptedFiles.map((file) => <li key={file.path}>{file.path} bytes</li>);

  const fileSizes = acceptedFiles.map((file) => <li key={file.path}>{file.size} bytes</li>);

  const handleChange = (e) => {
    e.preventDefault();
    console.log('e doc type change', e.target.value);
    setDocType(e.target.value);
    document.DocumentType = e.target.value;
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <>
      <FormControl>
        <Select
          labelId="document-label"
          id="documentType"
          displayEmpty
          value={document.DocumentType}
          onChange={handleChange}
          size="small"
        >
          <MenuItem value={0} disabled>
            Select Document Type
          </MenuItem>
          <MenuItem value={1}>Member ID Document</MenuItem>
          <MenuItem value={2}>Payslip</MenuItem>
          <MenuItem value={23}>Retirement Letter</MenuItem>
          <MenuItem value={34}>Birth Doc</MenuItem>
          <MenuItem value={35}>Proof of Death</MenuItem>
          <MenuItem value={36}>Claimant ID</MenuItem>
          <MenuItem value={37}>ClaimForm</MenuItem>
          <MenuItem value={38}>Affidavit</MenuItem>
          <MenuItem value={39}>Nomination Form</MenuItem>
          <MenuItem value={40}>Marriage Doc</MenuItem>
        </Select>
      </FormControl>
      <div className="container" style={{ marginBottom: 15 }}>
        <div {...getRootProps({ style })}>
          <input {...getInputProps()} />
          <p>Drag 'na' drop some files here, or click to select files</p>
          <button type="button" onClick={openDialog}>
            Open File Dialog
          </button>
        </div>
        <Box sx={{ width: '100%' }}>
          <Controls.LinearProgressWithLabel value={progres} />
        </Box>
        {show && (
          <div>
            <Typography variant="subtitle1" gutterBottom>
              <b>Uploading Files</b>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" gutterBottom>
                  <b>Name</b> {fileNames}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={1.5}>
                <Typography variant="body2" gutterBottom>
                  <b>Progress</b> <li> {progres} %</li>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography variant="body2" gutterBottom>
                  <b>File size</b> {fileSizes}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={1}>
                <Button variant="contained" color="secondary" onClick={setShow(false)}>
                  Done
                </Button>
              </Grid>
              <Grid item xs={12} sm={1}>
                <Button variant="contained" color="primary">
                  Remove
                </Button>
              </Grid>
            </Grid>
            <Controls.Notification notify={notify} setNotify={setNotify} />
          </div>
        )}
      </div>
    </>
  );
}
